<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="d-flex text-uppercase justify-content-center align-items-center mt-5 mb-10">
      <BaseIcon size="xSmall">
        <HomeIcon />
      </BaseIcon>
      <h1 class="ms-5 mb-0 font-size-medium">{{ $t('dashboard') }}</h1>
    </div>

    <template v-if="loader" class="text-center">
      <Loader
        :size="'big'"
      />
    </template>

    <template v-else>
      <!-- begin: new dashboards -->
      <template v-if="hasActiveCampaigns">
        <div class="my-2 text-color2 font-size-small py-2 mb-5 col-lg-10 mx-auto">
          <h2 class="text-center">{{ $t('new_dashboards.welcome') }}</h2>
          <p>
            {{ $t('new_dashboards.description') }}
          </p>
          <p>
            {{ $t('new_dashboards.explore') }}
            <router-link :to="{ name: 'dashboards.index' }">{{ $t('click_here') }}</router-link>
          </p>
        </div>

        <div v-if="user">
          <iframe
            v-if="user.dashboard_url"
            :src="user.dashboard_url"
            height="1550"
            width="100%"
          ></iframe>
        </div>
      </template>
      <!-- begin: new dashboards -->

      <!-- begin: homepage content -->
      <template v-else>
        <CreateCampaign
          :title="title"
          :subTitle="$t('how_would_you_like_to_advertise_today')"
        ></CreateCampaign>
      </template>
    </template>
    <!-- end: homepage content -->
  </MainLayout>
</template>

<script>
import BaseIcon from '@/components/common/Icon/BaseIcon'
import CampaignsService from '@/v1/modules/campaigns/services/campaigns-service'
import CreateCampaign from '@/components/campaigns/CreateCampaign.vue'
import HomeIcon from '@/components/common/Icon/HomeIcon'
import MainLayout from '@/components/layouts/MainLayout'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

import Loader from '@/v1/components/common/Loader/Loader.vue'

import { mapState } from 'vuex'

export default {
  components: {
    BaseIcon,
    CreateCampaign,
    HomeIcon,
    Loader,
    MainLayout,
    Shortcuts
  },
  data () {
    return {
      loader: true,
      hasActiveCampaigns: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    title () {
      return `${this.$t('hello')}, ${this.user?.name}`
    }
  },
  metaInfo () {
    return {
      title: 'Home'
    }
  },
  mounted () {
    this.getCampaigns()
  },
  methods: {
    /**
     * Get campaigns
     */
    async getCampaigns () {
      if (!this.user) return false
      try {
        const campaigns = await CampaignsService.getCampaigns({
          companyId: this.user?.company.id,
          status: 'ACTIVE'
        })

        if (campaigns.data.length > 0) {
          this.hasActiveCampaigns = true
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  },
  watch: {
    user () {
      this.getCampaigns()
    }
  }
}
</script>
